'use client';

import LatLngLiteral = google.maps.LatLngLiteral;
import FocusMap from "@/app/__to_be_integrated/_____components/map/FocusMap";
import { ControlPosition } from "@vis.gl/react-google-maps";
import useIsDesktop from "@/hooks/useDesktop";
import AuthenticPlacesMarker from "@/app/features/sites/authentic-places/ui/shared/AuthenticPlacesMarker";
import { AuthenticPlace } from "@/app/lib/generated/graphql-types";

interface AuthenticPlacesMapViewProps {
    places: AuthenticPlace[];
}

export default function AuthenticPlacesMapView({ places }: AuthenticPlacesMapViewProps) {
    const isDesktop = useIsDesktop();

    const locations: LatLngLiteral[] = places.map(place => ({ ...place.location! }));

    return (
        <FocusMap
            mapId={process.env.NEXT_PUBLIC_MAPS_ID_AUTHENTIC_PLACES!}
            mapTypeId='terrain'
            fitPoints={locations}
            overlay={{
                left: isDesktop ? .5 : 0.05,
                right: isDesktop ? 0 : 0.05,
                top: isDesktop ? 0 : 0.05,
                bottom: isDesktop ? 0 : 0.05,
            }}
            zoomControl
            zoomControlOptions={{
                position: ControlPosition.RIGHT_BOTTOM
            }}
            consentPosition={{ vertical: "center", horizontal: "right" }}
            lockInPlace
        >
            {places.map((place) =>
                <AuthenticPlacesMarker key={place.documentId} place={place} showExploreButton showRouteDescription={isDesktop} />
            )}

        </FocusMap>
    )
}
